import { TParentTaskDto, TSubTaskDto } from '@homepal/api-contract'
import { TCustomizedMetric } from './GlobalMetric'

export enum ETaskStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE'
}
export type TTask = TParentTaskDto<TCustomizedMetric>

export type TSubTask = TSubTaskDto<TCustomizedMetric>
